import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-skeleton-loader',
    templateUrl: './skeleton-loader.component.html',
    styleUrls: ['./skeleton-loader.component.scss'],
    standalone: false
})
export class SkeletonLoaderComponent implements OnInit {

  @Input() config!: any;

  constructor() { }

  ngOnInit(): void {
  }

}
